import React from 'react';
import { LayoutHeaderContext } from '@/providers/LayoutHeaderProvider';

export const useLayoutHeader = () => {
  const { height, useResizeEffect } = React.useContext(LayoutHeaderContext);

  return { headerHeight: height, useHeaderResizeEffect: useResizeEffect };
};
